import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { CommitToStoresAndCompletePurchaseLogDto } from "@interfaces/commitToStoresAndCompletePurchaseLogDto.interface";
import { PurchaseLogFileLink } from "@interfaces/purchaseLogFileLink.interface";
import { PurchaseLogLineItem } from "@interfaces/purchaseLogLineItem.interface";
import { AuthService } from "@services/auth.service";
import { FileService } from "@services/file.service";
import { PurchaseLogService } from "@services/purchaseLog.service";
import { SiteService } from "@services/site.service";
import { StockStoreService } from "@services/stockStore.service";
import { ToastService } from "angular-toastify";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "purchaseDetail",
	styleUrls: ["purchaseDetail.css"],
	templateUrl: "purchaseDetail.html"
})
export class PurchaseDetailComponent {
	dateTime: Date = new Date();
	incorrectItems: PurchaseLogLineItem[] = [];
	isIncorrect = false;
	isLoading = false;
	isUploading = false;
	lineItems: PurchaseLogLineItem[] = [];
	lineItemsComplete: number[] = [];
	notReceived = false;
	palletOrderLabel = "ORDER #PO-2024-001 - ACME Corporation";
	pallets: { index: number; items: number | null }[] = [];
	purchaseLog: any;
	purchaseLogId = 0;
	purchaseTypes: any[] = [];
	selectedLine: PurchaseLogLineItem = new PurchaseLogLineItem();
	showMoreInfo = false;
	showPalletModal = false;
	showPopup = false;
	showUploadModal = false;
	siteName = "";
	storesToCommit: PurchaseLogLineItem[] = [];
	totalPallets = 0;
	uploadFile: File | null = null;
	uploadModalStep: 1 | 2 = 1;
	uploadPin = "";
	uploadPinError = "";

	constructor(private route: ActivatedRoute, private authService: AuthService, private fileService: FileService, private purchaseLogService: PurchaseLogService, private siteService: SiteService, private stockStoreService: StockStoreService, private toastService: ToastService) {
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);
		this.route.params
			.subscribe(async (params) => {
				this.purchaseLogId = Number.parseInt(params.id);
				this.getPurchaseLog(Number.parseInt(params.id));
			});
	}

	beenLogged(lineNum: number) {
		if (this.purchaseLog.orderReceived) { return true; }
		return (this.storesToCommit.filter(x => x.lineNumber === lineNum).length > 0 || this.incorrectItems.filter(x => x.lineNumber === lineNum).length > 0);
	}

	cancelPalletModal(): void {
		this.showPalletModal = false;
	}

	checkAllLogged() {
		let allLogged = true;
		this.lineItems.forEach(line => {
			if (this.storesToCommit.filter(x => x.lineNumber === line.lineNumber).length < 1 && this.incorrectItems.filter(x => x.lineNumber === line.lineNumber).length < 1) {
				allLogged = false;
			}
		});
		return allLogged;
	}

	closeUploadModal(): void {
		this.showUploadModal = false;
		this.uploadModalStep = 1;
		this.uploadPin = "";
		this.uploadPinError = "";
		this.uploadFile = null;
		this.isUploading = false;
	}

	commitToStores(logLine: PurchaseLogLineItem) {
		this.stockStoreService.app_Received(this.purchaseLogId, logLine)
			.subscribe(
				(res: any) => {
					this.purchaseLog = res.response;
					console.log(res.response.lineItems);
					this.lineItems = JSON.parse(res.response.lineItems);
					console.log(this.lineItems);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	completePL() {
		const commitInfo = new CommitToStoresAndCompletePurchaseLogDto();
		commitInfo.isMissingItems = (this.notReceived || this.isIncorrect);
		commitInfo.palletLineItemsToCommit = JSON.stringify(this.storesToCommit);
		commitInfo.purchaseLogId = this.purchaseLogId;

		this.stockStoreService.app_CommitToStoresAndCompletePurchaseLog(commitInfo)
			.subscribe(
				() => {
					this.toastService.success("Goods Logged");
					this.printDialog();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	confirmAndUpload(): void {
		if (!this.uploadFile) { return; }
		this.isUploading = true;
		const uploadData = new FormData();
		uploadData.append("containerName", "purchaselogfiles");
		uploadData.append("files", this.uploadFile);
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.saveDocumentToPurchaseLog(res.response[0].lookupId, res.response[0].name);
				},
				(err) => {
					console.log(err);
					this.isUploading = false;
					this.toastService.error("Document upload failed. Please try again.");
				}
			);
	}

	enterNotReceived(log: PurchaseLogLineItem) {
		this.lineItems.find(x => x.lineNumber == log.lineNumber)!.received = 0;
		this.incorrectItems.push(log);
		this.notReceived = true;
	}

	enterQuantityReceived(log: PurchaseLogLineItem) {
		// Goods checked?
		if (window.confirm("If goods have been checked click confirm") == false) { return; }
		// if yes, goods acceptable?
		if (window.confirm("If goods have are acceptable click confirm") == false) { return; }
		const origQty = log.quantity;
		const input = window.prompt("Enter Quantity Received", log.quantity.toString());
		if (input == null) {
			return;
		}
		const inputCon = parseFloat(input!);
		this.lineItems.find(x => x.lineNumber == log.lineNumber)!.received = inputCon;

		//if full quantity not received pop it in the incorrect pile.
		if (inputCon < log.quantity) {
			this.incorrectItems.push(this.lineItems.find(x => x.lineNumber == log.lineNumber)!);
		}

		const totalPallets = window.prompt("Enter Total Pallets for Item.", "1");

		const totalPalletsCon = Number.parseInt(totalPallets!);
		console.log(totalPalletsCon);
		if (totalPallets != null) {
			if (totalPalletsCon > 1) {
				let i = 1;
				while (i <= totalPalletsCon) {
					console.log("Pallet Number" + i);
					const palletQtyInput = window.prompt("Enter Quantity for Pallet " + i, "0");
					const palletQty = parseFloat(palletQtyInput!);
					const tempLog = log;
					tempLog.quantity = palletQty;
					this.commitToStores(tempLog);
					i++;
				}
			} else {
				// Just the one.
				this.commitToStores(log);
				const tempLog = log;
				tempLog.quantity = inputCon;
			}
			this.lineItemsComplete.push(log.lineNumber);
			log.quantity = origQty;
		}
	}

	getPurchaseLog(id: number) {
		this.purchaseLogService.app_GetById(id)
			.subscribe(
				(res: any) => {
					this.purchaseLog = res.response;
					console.log(res.response.lineItems);
					this.lineItems = JSON.parse(res.response.lineItems);
					console.log(this.lineItems);
					this.siteName = res.response.site.name.toUpperCase();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	get getProgressPercentage(): number {
		if (this.getTotalItems === 0) {
			return 0;
		}
		return Math.round((this.getReceivedCount / this.getTotalItems) * 100);
	}

	get getReceivedCount(): number {

		if (this.purchaseLog.orderReceived) { return this.lineItems.length; } else {
			let allLogged = 0;
			this.lineItems.forEach(line => {
				if (this.storesToCommit.filter(x => x.lineNumber === line.lineNumber).length > 0 && this.incorrectItems.filter(x => x.lineNumber === line.lineNumber).length > 0) {
					allLogged = allLogged + 1;
				}
			});
			return allLogged;
		}
		return this.lineItemsComplete.length;
	}

	get getTotalItems(): number {
		return this.lineItems.length;
	}

	goBack() {
		window.history.back();
	}

	get isPalletFormValid(): boolean {
		if (!this.palletFormStarted) {
			return false;
		}
		if (!this.pallets.length) {
			return false;
		}
		return this.pallets.every(p => p.items !== null && p.items! > 0);
	}

	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		if (input.files && input.files.length > 0) {
			this.uploadFile = input.files[0];
		}
	}

	onTotalPalletsChange(): void {
		const count = this.totalPallets === null || this.totalPallets === undefined ? 0 : Math.floor(this.totalPallets);
		this.totalPallets = count;

		if (count <= 0) {
			this.pallets = [];
			return;
		}
		const newPallets: { index: number; items: number | null }[] = [];
		for (let i = 1; i <= count; i++) {
			const existing = this.pallets.find(p => p.index === i);
			newPallets.push({
				index: i,
				items: existing ? existing.items : null
			});
		}
		this.pallets = newPallets;
	}

	onUploadPinBackspace(): void {
		this.uploadPin = this.uploadPin.slice(0, -1);
	}

	onUploadPinDigit(digit: string): void {
		if (this.uploadPin.length < 8) {
			this.uploadPin += digit;
		}
	}

	openPalletModal(item: any): void {
		this.showPalletModal = true;
		this.selectedLine = item;
		this.palletOrderLabel = item.lineDescription;
		// initialise/refresh for each open – you can keep previous state if you prefer
		this.totalPallets = 0;
		this.pallets = [];
	}

	openUploadModal(): void {
		this.uploadModalStep = 1;
		this.uploadPin = "";
		this.uploadPinError = "";
		this.uploadFile = null;
		this.isUploading = false;
		this.showUploadModal = true;
	}

	get palletFormStarted(): boolean {
		return (this.totalPallets ?? 0) > 0;
	}

	printDialog() {
		if (window.confirm("Please enter " + this.purchaseLogId + " at the kiosk") == false) { return; }
		this.goBack();
	}

	renderDate(date: string) {
		return new Date(date).toLocaleDateString("en-GB");
	}

	renderPlogLineItems(lineItems: string) {
		const lineItemsConverted: PurchaseLogLineItem[] = JSON.parse(lineItems);
		return (lineItemsConverted.length);
	}

	renderPlogType(id: number) {
		return this.purchaseTypes.filter(x => x.id == id)[0].name;
	}

	saveDocumentToPurchaseLog(lookupId: string, fileName: string): void {
		const existingDocs: PurchaseLogFileLink[] = this.purchaseLog.supportingDocuments
			? JSON.parse(this.purchaseLog.supportingDocuments)
			: [];
		existingDocs.push(new PurchaseLogFileLink({ description: "Delivery Note / PO", fileName, lookupId }));
		const updatedLog = { ...this.purchaseLog, supportingDocuments: JSON.stringify(existingDocs) };
		this.purchaseLogService.updateSingleById(this.purchaseLog.id, updatedLog)
			.subscribe(
				() => {
					this.purchaseLog.supportingDocuments = JSON.stringify(existingDocs);
					this.isUploading = false;
					this.toastService.success("Document uploaded successfully.");
					this.closeUploadModal();
				},
				(err) => {
					console.log(err);
					this.isUploading = false;
					this.toastService.error("Failed to save document to purchase log.");
				}
			);
	}

	savePalletDetails(): void {
		if (!this.isPalletFormValid) {
			return;
		}
		console.log("Pallet details saved:", {
			pallets: this.pallets,
			totalPallets: this.totalPallets
		});
		let qtyCount = 0;
		console.log("Line Number: ", this.selectedLine.lineNumber);
		this.pallets.forEach(pallet => {
			console.log("Pallet: ", pallet.index);
			console.log("Items: ", pallet.items);
			if (pallet.items !== null) {
				const tempLine = { ...this.selectedLine };
				tempLine.quantity = pallet.items;
				console.log("Temp Line Qty: ", tempLine.quantity);
				qtyCount += tempLine.quantity;
				this.storesToCommit.push(tempLine);
			}
		});
		const lineItem = this.lineItems.find(x => x.lineNumber === this.selectedLine.lineNumber)!;
		if (lineItem.received === undefined || lineItem.received === null) {
			lineItem.received = 0;
		}
		lineItem.received += qtyCount;
		if (this.selectedLine.quantity != qtyCount) { this.isIncorrect = true; }
		this.showPalletModal = false;
	}

	submitUploadPin(): void {
		if (this.uploadPin.length < 4) { return; }
		this.authService.loginEmployeeCode(this.uploadPin)
			.subscribe(
				() => {
					this.uploadModalStep = 2;
					this.uploadPinError = "";
				},
				() => {
					this.uploadPinError = "Invalid PIN. Please try again.";
					this.uploadPin = "";
				}
			);
	}

	toggleMoreInfo() {
		this.showPopup = !this.showPopup;
		this.showMoreInfo = !this.showMoreInfo;
	}

	get uploadedDocumentCount(): number {
		if (!this.purchaseLog?.supportingDocuments) { return 0; }
		try {
			return JSON.parse(this.purchaseLog.supportingDocuments).length;
		} catch {
			return 0;
		}
	}
}